import { Component, OnDestroy, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BaseparameterService, ParameterConfigResponse } from '../../core/base-api';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Subscription } from 'rxjs';

@Component({
  selector: 'cap-rechte-hinweis',
  templateUrl: './rechte-hinweis.component.html',
  styleUrls: ['./rechte-hinweis.component.scss'],
  imports: [TranslatePipe]
})
export class RechteHinweisComponent implements OnInit, OnDestroy {
  startSeiteHtmlContent: SafeHtml;
  private translateSubscription: Subscription;
  private parameterSubscription: Subscription;
  parameters: { [key: string]: object };
  isloading = false;
  private deploymentMode = (window as any).environment.deploymentMode;

  constructor(
    private parameterService: BaseparameterService,
    protected translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    keysToTranslate<string>([
      'dashboard.rechtehinweis.legalHintHeader',
      'dashboard.rechtehinweis.legalHintComment',
      'dashboard.rechtehinweis.legalHintMessage',
      'dashboard.rechtehinweis.legalHintComment1'
    ]);
  }

  ngOnInit() {
    this.isloading = true;
    this.parameterSubscription = this.parameterService.getAllParameter().subscribe((value) => {
      this.parameters = value.parameters;
      this.updateStartseitenText();
      this.isloading = false;
    });

    this.translateSubscription = this.translate.onLangChange.subscribe(() => {
      this.updateStartseitenText();
    });
  }

  updateStartseitenText() {
    let key: string;

    if (this.deploymentMode === 'PUBLIC') {
      switch (this.translate.getCurrentLang()) {
        case 'de':
          key = ParameterConfigResponse.StartseiteTextParameterEnum.STARTSEITE_TEXT_INTERCAPI_PUBLIC_DEUTSCH_EDITIEREN;
          break;
        case 'fr':
          key = ParameterConfigResponse.StartseiteTextParameterEnum.STARTSEITE_TEXT_INTERCAPI_PUBLIC_FRANZOESISCH_EDITIEREN;
          break;
        default:
          key = ParameterConfigResponse.StartseiteTextParameterEnum.STARTSEITE_TEXT_INTERCAPI_PUBLIC_DEUTSCH_EDITIEREN;
      }
    } else {
      switch (this.translate.getCurrentLang()) {
        case 'de':
          key = ParameterConfigResponse.StartseiteTextParameterEnum.STARTSEITE_TEXT_INTERCAPI_DEUTSCH_EDITIEREN;
          break;
        case 'fr':
          key = ParameterConfigResponse.StartseiteTextParameterEnum.STARTSEITE_TEXT_INTERCAPI_FRANZOESISCH_EDITIEREN;
          break;
        case 'it':
          key = ParameterConfigResponse.StartseiteTextParameterEnum.STARTSEITE_TEXT_INTERCAPI_ITALIENISCH_EDITIEREN;
          break;
        default:
          key = ParameterConfigResponse.StartseiteTextParameterEnum.STARTSEITE_TEXT_INTERCAPI_DEUTSCH_EDITIEREN;
      }
    }

    if (this.parameters) {
      const rawHtml = this.getParameterValue(this.parameters, key) as unknown as string;
      if (rawHtml) {
        this.startSeiteHtmlContent = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
      } else {
        this.startSeiteHtmlContent = null;
      }
    }
  }

  getParameterValue(parameters: { [key: string]: object }, key: string): object | undefined {
    return parameters[key];
  }

  ngOnDestroy() {
    if (this.translateSubscription) {
      this.translateSubscription.unsubscribe();
    }
    if (this.parameterSubscription) {
      this.parameterSubscription.unsubscribe();
    }
  }
}
